var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestaurantCircleCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DF1E5B",
    d: "M11.375 20.438c-.379-.378-.413-.97-.104-1.388l.104-.12 4.93-4.93-4.93-4.93c-.379-.379-.413-.971-.104-1.388l.104-.12c.378-.378.97-.413 1.387-.103l.12.103 5.684 5.684c.379.379.413.97.103 1.388l-.103.12-5.684 5.684c-.416.416-1.091.416-1.507 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantCircleCaret);
export default __webpack_public_path__ + "static/media/restaurant-circle-caret.bc9b751e38cb08f311811d74d8a2488b.svg";
export { ForwardRef as ReactComponent };